import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setInitialTableState } from 'Store';

function useInitialTableState(tableName?: string) {
    const dispatch = useDispatch();
    const persistedState = useSelector((state: any) => state.tablesReducer[tableName ?? '']);
    const setPersistedState = React.useCallback(
        (payload: Omit<Parameters<typeof setInitialTableState>[0], 'name'>) => {
            if (tableName) {
                dispatch(setInitialTableState({ ...payload, name: tableName }));
            }
        },
        [dispatch, tableName]
    );

    return {
        setPersistedState,
        persistedState
    };
}

export default useInitialTableState;
